"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Translate = require("../../redux/i18n/Translate");

var _Translate2 = _interopRequireDefault(_Translate);

require("./Credits.scss");

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _mobile = require("redux/modules/mobile");

var mobileActions = _interopRequireWildcard(_mobile);

var _scroll = require("redux/modules/scroll");

var scrollActions = _interopRequireWildcard(_scroll);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Credits = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return {
    isMobile: state.mobile.isMobile,
    isTablet: state.mobile.isTablet
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)((0, _extends3.default)({}, scrollActions), dispatch);
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Credits, _Component);

  function Credits() {
    (0, _classCallCheck3.default)(this, Credits);
    return (0, _possibleConstructorReturn3.default)(this, (Credits.__proto__ || (0, _getPrototypeOf2.default)(Credits)).apply(this, arguments));
  }

  (0, _createClass3.default)(Credits, [{
    key: "render",
    value: function render() {
      var _props$strings$Credit = this.props.strings.Credits,
          items = _props$strings$Credit.items,
          verEspecial = _props$strings$Credit.verEspecial,
          titleCreditos = _props$strings$Credit.titleCreditos;


      return _react2.default.createElement(
        "div",
        { className: "Credits" },
        _react2.default.createElement(
          "div",
          { className: "Credits__especialEntierro" },
          _react2.default.createElement(
            "a",
            { href: verEspecial.link, target: "_blank", className: "Credits__especialEntierro__link" },
            _react2.default.createElement("i", { className: "icon-group-24 Credits__especialEntierro__link__icon" }),
            verEspecial.text
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "Credits__title" },
          _react2.default.createElement(
            "p",
            { className: "Credits__title__text" },
            titleCreditos
          )
        ),
        _react2.default.createElement(
          "ul",
          { className: "Credits__list" },
          items.map(function (item, index) {
            return _react2.default.createElement(
              "li",
              { key: index, className: "Credits__list__item" },
              _react2.default.createElement(
                "p",
                { className: "Credits__list__item__title" },
                item.title
              ),
              _react2.default.createElement("p", { className: "Credits__list__item__description", dangerouslySetInnerHTML: { __html: item.description || "" } })
            );
          })
        ),
        _react2.default.createElement(
          "div",
          { className: "Credits__logo" },
          _react2.default.createElement(
            "a",
            {
              className: "Credits__logo__link",
              href: "http://www.rtve.es/lab/",
              target: "_blank",
              title: "Ir a Lab RTVE"
            },
            _react2.default.createElement("div", { className: "Credits__logo__icon icon-logo-lab" })
          )
        )
      );
    }
  }]);
  return Credits;
}(_react.Component)) || _class);
exports.default = (0, _Translate2.default)("Home")(Credits);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Credits/Credits.js
// module id = 696
// module chunks = 0